import { useAvailabilityView } from 'app/components/availability-view/useAvailabilityView'
import { AvailabilityViewComponent } from 'app/components/availability-view/AvailabilityViewComponent'

export default function Availability() {
  const hookData = useAvailabilityView()
  return <AvailabilityViewComponent {...hookData} />
}
